import { createAction } from '@reduxjs/toolkit'
import { Question } from 'src/types/common'
import { AssessmentDxResultType } from './reducer'

export const userAssessmentDxSetQuestions = createAction<Question[]>('USER_ASSESSMENT_DX_SET_QUESTIONS')
export const userAssessmentDxSetResult = createAction<AssessmentDxResultType>('USER_ASSESSMENT_DX_SET_RESULT')
